import { Controller, useFormContext } from "react-hook-form";
import { Switch, SwitchProps } from "@heroui/react";

function SwitchInput({
    name,
    label,
    ...props
}: {
    name: string;
    label?: string;
} & SwitchProps) {
    const f = useFormContext();
    return (
        <Controller
            name={name}
            control={f.control}
            render={({ field: { value, onChange, onBlur } }) => {
                return (
                    <Switch
                        {...props}
                        value={value}
                        onValueChange={onChange}
                        onBlur={onBlur}
                    >
                        {label}
                    </Switch>
                );
            }}
        />
    );
}
export default SwitchInput;
